module.exports = __webpack_public_path__ + "img/passwordIconWhite.f68b7fd6.svg";